/* eslint-disable @typescript-eslint/no-unused-vars */
const getMockLODashboard = async () => {
  const mockData = {
    "openLoans" : [
      {
        name: "Glenn Ridge Condominiums",
        type: "New Construction",
        amount: 4000000
      },
      {
        name: "Emerald City Development",
        type: "Development",
        amount: 3450000.15
      }
    ],
    "closedLoans" : [
      {
        name: "Glenn Ridge Condominiums",
        type: "New Construction",
        amount: 5000000
      },
      {
        name: "Emerald City Development",
        type: "Development",
        amount: 3450000.45
      },
      {
        name: "Cool Cat Condos",
        type: "All in One",
        amount: 750500
      }
    ],
    "alerts": [
      {
        action: "upload",
        date: "12/3/2020",
        owner: "Catherine Quinn",
        documentType: "plans",
        projectName: "Market Street Condos"
      },
      {
        action: "closed",
        date: "12/2/2020",
        projectName: "Tokyo Towers"
      },
      {
        action: "created",
        date: "12/1/2020",
        projectName: "Cool Cat Condos"
      },
      {
        action: "upload",
        date: "11/29/2020",
        owner: "Jeffrey Jou",
        documentType: "June Bank Statement",
        projectName: "Market Street Condos"
      },
    ],
    "closingMonths": [
      {
        "monthNumber": 6,
        "monthName": "June",
        "closingAmount": 675000
      },
      {
        "monthNumber": 7,
        "monthName": "July",
        "closingAmount": 790000
      },
      {
        "monthNumber": 8,
        "monthName": "August",
        "closingAmount": 490000
      },
      {
        "monthNumber": 9,
        "monthName": "September",
        "closingAmount": 880000
      },
      {
        "monthNumber": 10,
        "monthName": "October",
        "closingAmount": 650000
      },
      {
        "monthNumber": 11,
        "monthName": "November",
        "closingAmount": 650000
      }
    ],
    "projectTypes": [
      {
        "projectTypeName": "Fix and Flip",
        "projectTypeTotal": 4000000
      },
      {
        "projectTypeName": "Construction",
        "projectTypeTotal": 100005
      },
      {
        "projectTypeName": "Bridge",
        "projectTypeTotal": 50000
      }
    ],
    "events": [
      {
        type: "amendment",
        date: "12/25/2020",
        event: "Green Gables Matures"
      },
      {
        type: "amendment",
        date: "12/26/2020",
        event: "Market Street Condos Matures"
      },
      {
        type: "review",
        date: "12/26/2020",
        event: "Market Street Condos Closes"
      },
      {
        type: "amendment",
        date: "12/27/2020",
        event: "Cool Cat Condos Matures"
      }
    ],
  };

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockDeals = async () => {
  const mockData = [
    {
      index: 0,
      name: "Lead",
      cards: [
        {
          id: "78f1b827-135c-43a5-a250-36e13fc089f8",
          name: "Lokal Builders",
          address: "1234 Main Street",
          loanAmount: 5000000,
          closing: "11/30/2020",
          completeness: 0.12,
          tags: [
            {
              type: "tc",
              value: "Danae"
            },
            {
              type: "lo",
              value: "Rob"
            }
          ]
        }
      ]
    },
    {
      index: 1,
      name: "Prequal/Pricing",
      cards: [
        {
          id: "17d90154-d3de-403a-a460-7973fcce09f1",
          name: "Super Builders",
          address: "1234 Main Street",
          loanAmount: 2000000.50,
          closing: "11/22/2020",
          completeness: 0.1533,
          tags: []
        },
        {
          id: "17d90154-d3de-403a-a460-7973fcce09f6",
          name: "Super Builders",
          address: "1234 Main Street",
          loanAmount: 100800.50,
          closing: "11/22/2020",
          completeness: 0.1533,
          tags: []
        },
        {
          id: "17d90154-d3de-403a-a460-7973fcce09f9",
          name: "Super Builders",
          address: "1234 Main Street",
          loanAmount: 2000.50,
          closing: "11/22/2020",
          completeness: 0.1533,
          tags: []
        }
      ]
    },
    {
      index: 2,
      name: "Processing",
      cards: []
    },
    {
      index: 3,
      name: "Analyst",
      cards: []
    },
    {
      index: 4,
      name: "LRC",
      cards: []
    },
    {
      index: 5,
      name: "Reviewed",
      cards: []
    },
    {
      index: 6,
      name: "Approved",
      cards: []
    },
    {
      index: 7,
      name: "Docs/Escow",
      cards: []
    },
    {
      index: 8,
      name: "Closed Won",
      cards: []
    }
  ];

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockDeal = async (id) => {
  const mockData = {
    summary: {
      id: "78f1b827-135c-43a5-a250-36e13fc089f8",
      name: "Lokal Builders",
      property: "Market Street Condos",
      address: "1234 Main Street",
      city: "Seattle",
      state: "WA",
      loanAmount: 5000000,
      closing: "11/30/2020",
      completeness: 0.12,
      tags: [
        {
          type: "tc",
          value: "Danae"
        },
        {
          type: "lo",
          value: "Rob"
        }
      ]
    },
    documents: [
      {
        address: "1234 Main Street",
        city: "Seattle",
        state: "WA",
        zip: 98103,
        parcelNumber: 98103,
        lotNumber: 1,
        zoning: "Residential",
        existingStructure: "Land",
        newStructure: "SFR",
        currentWorkStage: "No work started",
        units: []
      },
      {
        address: "1234 Main Street",
        city: "Seattle",
        state: "WA",
        zip: 98103,
        parcelNumber: 98103,
        lotNumber: 2,
        zoning: "Residential",
        existingStructure: "Land",
        newStructure: "SFR",
        currentWorkStage: "No work started",
        units: []
      }
    ]
  };

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockBorrowers = async () => {
  const mockData = [
    {
      name: "Mountain Magic, Inc",
      entitySubType: "",
      address: "1234 Main St.",
      city: "Seattle",
      state: "WA",
      zip: 98052,
      website: ""
    }
  ];

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

const getMockContacts = async () => {
  const mockData = [
    {
      firstName: "John",
      lastName: "Smith",
      address: "1234 Main St.",
      city: "Seattle",
      state: "WA",
      zip: 98052,
      phone: "111-222-3333"
    }
  ];

  return Promise.resolve({
    ok: true,
    json: () => mockData
  });
};

export {
  getMockLODashboard,
  getMockDeals,
  getMockDeal,
  getMockBorrowers,
  getMockContacts
};